import type { LabOrderErrorCode } from './bloodTests.types';
import { LabOrderError } from './labsApi';

export const IMPERSONATING_MESSAGE = 'Ekki er hægt að panta blóðprufur í nafni annars notanda.';

const ERROR_MESSAGES: Record<LabOrderErrorCode, string> = {
  lab_ordering_unavailable: 'Blóðprufupantanir eru ekki í boði fyrir þína stöð.',
  laeknanumer_required: 'Læknanúmer vantar. Skráðu það áður en þú pantar.',
  impersonation_not_allowed: IMPERSONATING_MESSAGE,
  invalid_request: 'Beiðnin var ógild. Athugaðu kennitölu og valdar rannsóknir.',
  lab_order_in_progress: 'Pöntun er þegar í vinnslu. Bíddu augnablik og athugaðu stöðuna áður en þú reynir aftur.',
  lab_order_failed: 'Ekki tókst að panta blóðprufur. Reyndu aftur.',
};

/** Icelandic copy for a failed catalog/order call; never echoes server text. */
export const labOrderErrorMessage = (error: unknown): string =>
  ERROR_MESSAGES[error instanceof LabOrderError ? error.code : 'lab_order_failed'];
